/**
 * Genera una URL absoluta para una imagen o recurso.
 * Maneja automáticamente las diferencias entre el entorno de desarrollo y producción.
 */
export const getImageUrl = (path: string | undefined | null): string => {
    if (!path) return '';

    // Si la URL ya es absoluta, la retornamos tal cual (el symlink se encarga del resto)
    if (path.startsWith('http')) {
        return path;
    }

    // Obtener la URL base desde las variables de entorno
    let baseUrl = (import.meta.env.VITE_API_URL_ASSETS as string) || '';

    const dynamicUrl = typeof window !== 'undefined' ? localStorage.getItem('dynamicApiUrl') : null;

    if (dynamicUrl) {
        baseUrl = dynamicUrl.endsWith('/api') ? dynamicUrl.substring(0, dynamicUrl.length - 4) : dynamicUrl;
    } else if (import.meta.env.PROD || (typeof window !== 'undefined' && (window.location.hostname.includes('duffigelato.com') || window.location.hostname.includes('blue-snail-706236.hostingersite.com')))) {
        const origin = typeof window !== 'undefined' ? window.location.origin : 'https://duffigelato.com';
        baseUrl = `${origin}/api`;
    } else if (typeof window !== 'undefined' && window.location.hostname && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        // Acceso por LAN (móvil, tablet ej: 192.168.x.x): usar el hostname del servidor en el puerto 8000
        baseUrl = `${window.location.protocol}//${window.location.hostname}:8000`;
    } else if (!baseUrl || baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1')) {
        // Fallback para entorno local
        baseUrl = 'http://127.0.0.1:8000';
    }

    // Si después de todo sigue estando vacío, usamos el origen actual como último recurso
    if (!baseUrl) {
        baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
    }

    // Normalizar: quitar barra final de base y asegurar barra inicial en path
    const cleanBase = baseUrl.replace(/\/$/, '');
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return `${cleanBase}${cleanPath}`;
};
